export function isValidPositiveDecimalInput(value: string | number | null | undefined): boolean {
  if (value === null || value === undefined || value === '') return false
  const normalized = String(value).replace(',', '.')
  return !isNaN(Number(normalized)) && isFinite(Number(normalized))
}

export function preventNonPositiveNumberKeys (e: KeyboardEvent): void {
  const invalid = ['e', 'E', '+', '-']
  if (invalid.includes(e.key)) e.preventDefault()
}